export const secureLink = link =>
  link ? link.replace('http:', 'https:') : link
